import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import EssentialLayout from "@/components/menu-management/manage-essential/essential-layout";
import { Card } from "@/components/ui/card";
import { TabsList, Tabs, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@/components/ui/separator";
import CetagoryTabs from "@/components/menu-management/manage-essential/essential-drinks/category/cetagory-tabs";
import { useParams } from "react-router-dom";
import useAuth from "@/hooks/useAuth";
import { useFetchAllMenuData } from "@/hooks/use-fetch-all-menu-data";
import { useMemo } from "react";
import EssentialSkeleton from "@/components/skeleton/essential-skeleton";

function EssentialComboMeal() {
  const { id } = useParams();
  const { user } = useAuth();
  const fetchOnly = useMemo(() => ["categories"], []);

  const { groupLoading } = useFetchAllMenuData(user?.restaurant_id, id, {
    fetchOnly,
  });

  if (groupLoading) return <EssentialSkeleton />;
  return (
    <Layout2 LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}>
      <EssentialLayout>
        <Card className="bg-transparent col-span-1 md:col-span-2">
          <Tabs
            valueKey="essential-combo-meal"
            className="bg-transparent relative"
            defaultValue="cetagoris"
          >
            <TabsList className="grid grid-cols-1 w-[150px]">
              <Separator className="absolute top-8" />
              <TabsTrigger className="bg-transparent" value="cetagoris">
                Categories
              </TabsTrigger>
            </TabsList>
            <CetagoryTabs />
          </Tabs>
        </Card>
      </EssentialLayout>
    </Layout2>
  );
}

export default EssentialComboMeal;
